export const nodeType = {
    StartNode: 'StartNode',
    EndNode: 'EndNode',
    SendMessageNode: 'SendMessageNode',
    OptionNode: 'OptionNode',
    ShareLinkNode: 'ShareLinkNode',
    ScriptNode: 'ScriptNode',
    AskForDetailNode: 'AskForDetailNode',
    SetVariableNode: 'SetVariableNode',
}